export default __webpack_public_path__ + "static/media/icon-rounded.e545e489.png";